module.exports = __webpack_public_path__ + "static/images/gruop-hw.4217705.png";